import { IScatterShapePlatePoint } from 'interfaces/i-pitch-performance';

const DOT_RADIUS_PX = 4;
const HOVER_RADIUS_PX = 8;

export const PlateDot = ({
  cx,
  cy,
  opacity = 1,
  payload,
  onMouseEnter,
  onMouseLeave,
}: IScatterShapePlatePoint) => {
  if (cx === undefined || cy === undefined || !payload) {
    return null;
  }

  return (
    <g
      opacity={opacity}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <circle
        cx={cx}
        cy={cy}
        r={HOVER_RADIUS_PX}
        fill="transparent"
        pointerEvents="all"
      />
      <circle
        cx={cx}
        cy={cy}
        r={DOT_RADIUS_PX}
        fill={`rgb(${payload.fillRgb})`}
        fillOpacity={0.75}
        stroke={`rgb(${payload.strokeRgb})`}
        strokeWidth={1}
      />
    </g>
  );
};
